<template>
  <div class="SendGridSummaryReportFilterBar">
    <div class="container-fluid">
      <div class="row margin-top-2Perc vertical-align">
        <div class="col-md-2 col-lg-2"></div>
        <div class="col-md-1 col-lg-1 text-align-right Padding-left-0px">
          Start date
        </div>
        <div class="col-md-2 col-lg-2 Padding-left-0px">
          <date-picker v-model="startDate" :config="config"></date-picker>
        </div>
        <div class="col-md-1 col-lg-1 text-align-right Padding-left-0px width-6Point3Perc">
          End date
        </div>
        <div class="col-md-2 col-lg-2 Padding-left-0px">
          <date-picker v-model="endDate" :config="config"></date-picker>
        </div>
        <div class="col-md-1 col-lg-1 padding-left-0Point5Perc">
          <button type="button" class="btn btn-default unenroll-existing-button-BG black-font-color" @click="checkAndEmit($event, false)">Show</button>
        </div>
        <div class="col-md-1 col-lg-1 Padding-left-0px">
          <button type="button" class="btn btn-default unenroll-existing-button-BG black-font-color" v-if="showExport" @click="checkAndEmit($event, true)">Export</button>
        </div>
        <div class="col-md-2 col-lg-1"></div>
      </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  </div>
</template>

<script>
import datePicker from 'vue-bootstrap-datetimepicker'
import moment from 'moment'
import AlertBox from '@/components/AlertOverlay'
export default {
  props: ['showExport'],
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    var startTS = moment().tz('America/New_York').format('MM/DD/YYYY')
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      startDate: startTS,
      config: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
        maxDate: ''
      },
      endDate: startTS
    }
  },
  components: {
    'alert-box': AlertBox,
    'date-picker': datePicker
  },
  methods: {
    setDefaultValues: function () {
      this.config.maxDate = new Date()
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    checkAndEmit: function (event, isExportBtnClicked) {
      if (this.startDate === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a start date.'
        return
      }
      if (this.endDate === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select an end date.'
        return
      }
      if (Date.parse(this.startDate) > Date.parse(this.endDate)) {
        this.showAlertDialog = true
        this.errorMsg = 'Start date must be less than the end date.'
        return
      }
      var obj = {
        emailObj: null,
        startDate: this.startDate,
        endDate: this.endDate
      }
      this.$emit('selectedObj', obj)
      if (isExportBtnClicked) {
        this.$emit('isExportBtnClicked', true)
        this.$emit('isViewBtnClicked', false)
      } else {
        this.$emit('isExportBtnClicked', false)
        this.$emit('isViewBtnClicked', true)
      }
    }
  },
  computed: {},
  name: 'SendGridSummaryReportFilterBar'
}
</script>

<style scoped>
.SendGridSummaryReportFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.AdminActivityFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.margin-top-2Perc{
    margin-top:2%;
}
.labelText {
    /* display: inline-flex; */
    /* height: 34px; */
    /* align-items: center; */
    /* font-size: 14px; */
    /* font-weight: 600; */
}
.black-border{
    border-left: 1px solid #aaa;
}
.padding-left-2Perc{
    padding-left:2%;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.text-align-right{
  text-align: right !important;
}
.Padding-left-0px {
  padding-left: 0px !important;
}
.margin-left-2Perc{
  margin-left:2%;
}
.center-div{
  margin: auto;
}
.padding-right-0px{
  padding-right:0%;
}
.width-6Point3Perc{
  width:6.3%;
}
.width-6Point8Perc{
  width:6.8%;
}
.unenroll-existing-button-BG {
    background-color: #f39c12 !important;
    border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.padding-left-0Point5Perc{
  padding-left:0.5%;
}
.align-center {
  margin: 0 auto !important;
  /* margin-right: 0 auto !important; */
}
</style>


// WEBPACK FOOTER //
// src/components/reports/send_grid/SendGridSummaryReportFilterBar.vue